import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const faqs = [{
  q: '¿El producto es digital?',
  a: 'Sí. 100% digital en formato PDF. Accedés inmediatamente después de comprar, con acceso de por vida.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Te llega por email con el link de descarga en menos de 5 minutos después del pago. Podés leerlo en celular, tablet o computadora. Podés imprimirlo si preferís trabajar en papel.'
}, {
  q: '¿Puedo verlo desde el celular?',
  a: 'Sí. Podés verlo desde celular, tablet o computadora. El material está optimizado para cualquier dispositivo.'
}, {
  q: '¿Sirve para relaciones personales y laborales?',
  a: 'Sí. El contenido aplica tanto para trabajo como para relaciones cotidianas (familia, pareja, amigos).'
}, {
  q: '¿Incluye todos los bonus?',
  a: 'Sí. Incluye los 5 bonus mostrados en la página, incluido el Bonus Premium de Personalidades Difíciles Explicadas.'
}, {
  q: '¿Necesito conocimientos previos?',
  a: 'No. Está explicado de forma clara, práctica y fácil de aplicar. El Módulo 1 te lleva desde cero absoluto.'
}, {
  q: '¿Cuánto tiempo tengo acceso al material?',
  a: 'Acceso de por vida. Una sola compra, para siempre. Sin mensualidades ni renovaciones.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días de garantía total sin preguntas. Si no es lo que esperabas, te devolvemos el 100% del dinero.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-78">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-79">
            <span className="text-xs font-bold tracking-widest" data-id="element-80">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-81">
            Preguntas{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-82">
              frecuentes
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-83">
          {faqs.map((f, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-white border border-line rounded-2xl overflow-hidden shadow-sm" data-id="element-84">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-5 md:p-6 text-left" data-id="element-85">
                <span className="font-semibold text-ink text-base md:text-lg pr-4" data-id="element-86">
                  {f.q}
                </span>
                <motion.div animate={{
              rotate: open === i ? 45 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-87">
                  <PlusIcon className="w-5 h-5 text-rose flex-shrink-0" data-id="element-88" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-89">
                {open === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} className="overflow-hidden" data-id="element-90">
                    <div className="px-5 md:px-6 pb-5 text-ink-soft" data-id="element-91">{f.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}